import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table14Data = { [key: string]: Table14Row };

export interface ITable14Props {
  data: Table14Data;
}

interface ITable14State {
}

export interface Table14Row {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

const sortOrder = [
  "Apparent Alcohol Involvement",
  "Alcohol Involvement Unknown",
  "No Alcohol Involvement",
  "TOTALS",
];

export default class Table14Summary extends React.Component<ITable14Props, ITable14State> {
  constructor(props: ITable14Props) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      this.props.data ?
        <React.Fragment>
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: '50%' }} />
              <col span={6} style={{ width: '8.3%' }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={3} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">14</span>
                    <span className="header-text">ALCOHOL INVOLVEMENT</span>
                  </div>
                </th>
                <th colSpan={7}>NUMBER OF CRASHES</th>
              </tr>
              <tr>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
                <th rowSpan={2}>PDO **</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].total}</td>
                  <td className="numberTotals">{this.props.data[key].fatal}</td>
                  <td className="numberTotals">{this.props.data[key].injuryA}</td>
                  <td className="numberTotals">{this.props.data[key].injuryB}</td>
                  <td className="numberTotals">{this.props.data[key].injuryC}</td>
                  <td className="numberTotals">{this.props.data[key].pdo}</td>
                </tr>
              )}
            </tbody>
          </table>
          <p className="notes">Includes drivers and/or non-motorists</p>
        </React.Fragment>
        : <p>Loading...</p>
    );
  }
}
